import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeJobTitleService } from '../employee-job-title/employee-job-title.service';
import { EmployeeJobTitleModel } from '../employee-job-title/model/employee-job-title.model';
import { EmployeeJobPositionService } from '../../employee-job-position/employee-job-position/employee-job-position.service';
import { EmployeeJobPositionModel } from '../../employee-job-position/employee-job-position/model/employee-job-position.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-employee-job-title-edit',
  templateUrl: './employee-job-title-edit.component.html',
  styleUrls: ['./employee-job-title-edit.component.scss'],
  standalone: false
})
export class EmployeeJobTitleEditComponent implements OnInit, DirtyCheck {
  title: string = "New Job Title";
  editForm: FormGroup;
  itemInfo: EmployeeJobTitleModel = { id: 0 };
  jobPositions: EmployeeJobPositionModel[] = [];
  employeeTypes = [
    { value: 'full_time', label: 'Full Time' },
    { value: 'part_time', label: 'Part Time' },
    { value: 'casual', label: 'Casual' },
    { value: 'contract', label: 'Contract' }
  ];
  isFormDirty: boolean = false;
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private service: EmployeeJobTitleService,
    private positionService: EmployeeJobPositionService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog) {

    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [null, [Validators.required, Validators.maxLength(50)]],
      name: [null, [Validators.required, Validators.maxLength(100)]],
      description: [null],
      job_position_id: [null, [Validators.required]],
      is_hq: [0],
      employee_type: ['full_time', [Validators.required]],
      is_active: [1]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    this.loadJobPositions();

    if (id !== null && parseInt(id) !== 0) {
      this.loadItem(id);
    }

    this.permission = permissionService.getPagePermission("employee");
  }

  ngOnInit(): void {}

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/employee/employee-job-title']);
  }

  loadJobPositions(): void {
    this.positionService.getList({ search: { filters: { scope: { limit: 1000, offset: 0 } } } }).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.jobPositions = response.data.job_positions;
      }
    });
  }

  loadItem(id: any): void {
    this.service.getById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.itemInfo = response.data.job_title;
          if (this.itemInfo) {
            this.itemInfo.is_hq = this.itemInfo.is_hq ? Number(this.itemInfo.is_hq) : 0;
            this.itemInfo.is_active = this.itemInfo.is_active ? Number(this.itemInfo.is_active) : 0;
          }
          this.editForm.patchValue(this.itemInfo);
          this.title = "Editing: " + this.itemInfo.name;
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      },
      error: () => {
        this.snackBarService.openSnackBar({ message: 'Failed to get data from server.', title: 'Failed!!!', type: 'error' });
      }
    });
  }

  save(): void {
    if (this.editForm.valid) {
      Object.assign(this.itemInfo, this.editForm.value);
      this.service.update(this.itemInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({ type: 'success', title: 'Saved', message: 'Record updated successfully.' });
            this.navBack();
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        },
        error: () => {
          this.snackBarService.openSnackBar({ message: 'Failed to update.', title: 'Failed!!!', type: 'error' });
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
